/* eslint-disable import/prefer-default-export */

export const getCurrentQuery = (state) => state.request.currentQuery;
